import { createStore } from 'vuex';
import blog from './modules/blog';
import news from './modules/news';
import enquiries from './modules/enquiries';
import legalDocs from './modules/legalDocs';

export default createStore({
  modules: {
    blog,
    news,
    enquiries,
    legalDocs
  }
});